class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', {bubbles: true});

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this)),
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	};
}

if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (let i = 0, count = selector.options.length; i < count; i++) {
		let option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	let method = options['method'] || 'post';
	let params = options['parameters'] || {};

	let form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (let key in params) {
		let hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};


class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('[type="button"]');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(this);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.mediaContentCache = null;
		this.addEventListener('change', this.onVariantChange);
	}

	connectedCallback() {
		this.cacheProductMediaContent();
	}

	cacheProductMediaContent() {
		const sectionId = this.dataset.section;
		const section = this.closest('section');
		if (!section) return;

		this.mediaContentCache = new Map();

		const storeContent = (element) => {
			const mediaId = element.dataset?.mediaId;
			if (!mediaId) return;
			const id = String(mediaId);
			if (this.mediaContentCache.has(id)) return;
			this.mediaContentCache.set(
				id,
				Array.from(element.childNodes).map((node) => node.cloneNode(true)),
			);
		};

		section
			.querySelectorAll('li[data-product-media-item][data-media-id]')
			.forEach(storeContent);

		const modalList = document.querySelector(
			`#ProductModal-${sectionId} ul`,
		);
		if (modalList) {
			modalList.querySelectorAll('[data-media-id]').forEach(storeContent);
		}
	}

	getTargetMediaId() {
		if (!this.currentVariant) return null;

		const featuredId = this.currentVariant.featured_media?.id;
		if (featuredId != null && featuredId !== '') {
			return String(featuredId);
		}

		const section = this.closest('section');
		const defaultId = section?.querySelector('[data-default-media-id]')
			?.dataset?.defaultMediaId;

		return defaultId ? String(defaultId) : null;
	}

	applyMediaContent(slide, mediaId) {
		const nodes = this.mediaContentCache?.get(String(mediaId));
		if (!nodes?.length) return false;
		slide.replaceChildren(...nodes.map((node) => node.cloneNode(true)));
		return true;
	}

	playProductMediaEnter(container) {
		if (!container) return;
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		container.classList.remove('is-media-entering');
		void container.offsetWidth;
		container.classList.add('is-media-entering');

		const media = container.querySelector('picture, video');
		if (!media) {
			container.classList.remove('is-media-entering');
			return;
		}

		media.addEventListener(
			'animationend',
			() => {
				container.classList.remove('is-media-entering');
			},
			{once: true},
		);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.removeErrorMessage();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value,
		);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateMedia() {
		if (!this.currentVariant) return;

		const mediaId = this.getTargetMediaId();
		if (!mediaId) return;

		if (!this.mediaContentCache) this.cacheProductMediaContent();

		const sectionId = this.dataset.section;
		const section = this.closest('section');

		if (section) {
			this.updateDesktopFeaturedMedia(section, sectionId, mediaId);
		}

		const mediaGallery = document.getElementById(
			`MediaGallery-${sectionId}`,
		);
		if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
			mediaGallery.setActiveMedia(`${sectionId}-${mediaId}`);
			const mobileSlide = mediaGallery.querySelector(
				`li[data-media-id="${mediaId}"]`,
			);
			this.playProductMediaEnter(mobileSlide);
		}

		const modalContent = document.querySelector(
			`#ProductModal-${sectionId} ul[role="document"]`,
		);
		if (!modalContent) return;
		const newMediaModal = modalContent.querySelector(
			`[data-media-id="${mediaId}"]`,
		);
		if (newMediaModal) modalContent.prepend(newMediaModal);
	}

	updateDesktopFeaturedMedia(section, sectionId, mediaId) {
		const featuredSlide = section.querySelector(
			'li[data-product-media-item][data-is-featured="true"]',
		);
		if (!featuredSlide) return;
		if (String(featuredSlide.dataset.mediaId) === mediaId) return;

		const prevMediaId = String(featuredSlide.dataset.mediaId);
		const targetSlide = section.querySelector(
			`li[data-product-media-item][data-media-id="${mediaId}"]:not([data-is-featured="true"])`,
		);

		if (targetSlide) {
			const featuredNodes = Array.from(featuredSlide.childNodes).map((node) =>
				node.cloneNode(true),
			);
			const targetNodes = Array.from(targetSlide.childNodes).map((node) =>
				node.cloneNode(true),
			);

			featuredSlide.replaceChildren(...targetNodes);
			targetSlide.replaceChildren(...featuredNodes);

			featuredSlide.setAttribute('data-is-featured', 'true');
			targetSlide.removeAttribute('data-is-featured');

			featuredSlide.dataset.mediaId = mediaId;
			targetSlide.dataset.mediaId = prevMediaId;

			featuredSlide.id = `Slide-${sectionId}-${mediaId}`;
			targetSlide.id = `Slide-${sectionId}-${prevMediaId}`;
			this.playProductMediaEnter(featuredSlide);
			return;
		}

		if (prevMediaId && prevMediaId !== mediaId) {
			const prevSlide = section.querySelector(
				`li[data-product-media-item][data-media-id="${prevMediaId}"]:not([data-is-featured="true"])`,
			);
			if (prevSlide) this.applyMediaContent(prevSlide, prevMediaId);
		}

		if (!this.applyMediaContent(featuredSlide, mediaId)) return;

		featuredSlide.dataset.mediaId = mediaId;
		featuredSlide.id = `Slide-${sectionId}-${mediaId}`;
		this.playProductMediaEnter(featuredSlide);
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState(
			{},
			'',
			`${this.dataset.url}?variant=${this.currentVariant.id}`,
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', {bubbles: true}));
		});
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const destination = document.getElementById(
					`price-${this.dataset.section}`,
				);
				const source = html.getElementById(
					`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
				);
				this.updateSourceFromDestination(html, 'price');
				this.updateSourceFromDestination(html, 'price-sticky');
				if (source && destination) destination.innerHTML = source.innerHTML;

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('visibility-hidden');
				this.toggleAddButton(
					window.variantStrings.soldOut,
					!this.currentVariant.available,
				);
			});
	}

  updateSourceFromDestination(html, id, shouldHide = (source) => false) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const source = html.getElementById(`${id}-${sectionId}`);
    const destination = document.getElementById(`${id}-${this.dataset.section}`);
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', shouldHide(source));
    }
  };

	toggleAddButton(text, disable = true, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('visibility-hidden');
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked,
			).value;
		});
	}
}

customElements.define('variant-radios', VariantRadios);

class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector(
				'input[name="language_code"], input[name="country_code"]',
			),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};
		this.elements.button.addEventListener(
			'click',
			this.openSelector.bind(this),
		);
		this.elements.button.addEventListener(
			'focusout',
			this.closeSelector.bind(this),
		);
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach((item) =>
			item.addEventListener('click', this.onItemClick.bind(this)),
		);
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('form');
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute('hidden');
		this.elements.button.setAttribute(
			'aria-expanded',
			(
				this.elements.button.getAttribute('aria-expanded') === 'false'
			).toString(),
		);
	}

	closeSelector(event) {
		const shouldClose =
			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);
